export default "__VITE_ASSET__BrlsioEN__"